import { Building2, Database, LineChart, Settings2, ShieldUser, Users } from '@tamagui/lucide-icons';
import { ScrollViewStyles } from '@unistocks/components/basic/scrollview';
import { Page } from '@unistocks/components/page/page';
import { DashboardCard } from '@unistocks/features/admin/components/dashboard-card/dashboard-card';
import { usePermission } from '@unistocks/shared/hooks/use-permission';
import { t } from '@unistocks/shared/localization/index.ts';
import { UnistocksPermissions } from '@unistocks/shared/permissions';
import React from 'react';
import { View } from 'tamagui';

export const AdminDashboard: React.FC = () => {
  const hasUserManagement = usePermission(UnistocksPermissions.UserManagement);
  const hasRoleManagement = usePermission(UnistocksPermissions.Roles);
  const hasTenantManagement = usePermission(UnistocksPermissions.TenantManagement);
  const hasAssetManagement = usePermission(UnistocksPermissions.AssetManagementList);
  const hasDataSourceManagement = usePermission(UnistocksPermissions.DataSourceManagement);
  const hasSettingManagementEmailing = usePermission(
    UnistocksPermissions.SettingManagementEmailing
  );
  const hasSettingManagementIdentity = usePermission(
    UnistocksPermissions.SettingManagementIdentity
  );
  const hasSettingManagementFeatures = usePermission(
    UnistocksPermissions.SettingManagementFeatures
  );

  const hasSettingManagement =
    hasSettingManagementEmailing || hasSettingManagementIdentity || hasSettingManagementFeatures;

  return (
    <Page>
      <Page.ScrollView
        headerTitle={t('::Menu:Administration')}
        /* For the hover effect on the cards */
        style={{ overflow: 'visible' }}
        contentContainerStyle={ScrollViewStyles.contentContainerStyle}
      >
        <View fd="column" $md={{ fd: 'row', flexWrap: 'wrap' }} gap={'$4'}>
          {hasUserManagement && (
            <DashboardCard
              href={'/(admin)/user-management'}
              Icon={Users}
              title={t('AbpIdentity::Menu:IdentityManagement')}
              description={t('AbpIdentity::Menu:IdentityManagement:Description')}
            />
          )}

          {hasRoleManagement && (
            <DashboardCard
              href={'/(admin)/role-management'}
              Icon={ShieldUser}
              title={t('AbpIdentity::Roles')}
              description={t('AbpIdentity::ManageRoles')}
            />
          )}

          {hasTenantManagement && (
            <DashboardCard
              href={'/(admin)/tenant-management'}
              Icon={Building2}
              title={t('AbpTenantManagement::Menu:TenantManagement')}
              description={t('AbpTenantManagement::Menu:TenantManagement:Description')}
            />
          )}

          {hasAssetManagement && (
            <DashboardCard
              href={'/(admin)/asset-management'}
              Icon={LineChart}
              title={t('::Menu:Assets')}
              description={t('::Menu:Assets:Description')}
            />
          )}

          {hasDataSourceManagement && (
            <DashboardCard
              href={'/(admin)/data-sources'}
              Icon={Database}
              title={t('::Menu:DataSources')}
              description={t('::Menu:DataSources:Description')}
            />
          )}

          {hasSettingManagement && (
            <DashboardCard
              href={'/(admin)/setting-management'}
              Icon={Settings2}
              title={t('AbpSettingManagement::Menu:Settings')}
              description={t('AbpSettingManagement::Permission:SettingManagement')}
            />
          )}
        </View>
      </Page.ScrollView>
    </Page>
  );
};

AdminDashboard.displayName = 'AdminDashboard';
